const steps = [
  { n: "01", t: "Kleid online auswählen", d: "Stöbere durch unsere Kollektion und finde dein Lieblingskleid." },
  { n: "02", t: "Anfrage per WhatsApp oder Formular", d: "Schick uns dein Wunschdatum – wir reservieren das Kleid für dich." },
  { n: "03", t: "Anprobe & kostenlose Anpassung", d: "Komm zur Anprobe in unser Schneider-Atelier – wir passen das Kleid individuell für dich an, kostenlos." },
  { n: "04", t: "Mieten, tragen & zurückbringen", d: "Strahle bei deinem Event – Reinigung ist inklusive." },
];

export default function HowItWorks() {
  return (
    <section id="so-funktionierts" data-testid="how-it-works" className="py-24 md:py-32 bg-white border-y border-[#E5E0D8]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="max-w-2xl mb-16">
          <div className="overline mb-4"><span className="gold-line" />In vier Schritten</div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05]">So funktioniert's</h2>
          <p className="mt-5 text-ink/70 max-w-lg">
            Vom ersten Blick bis zum großen Auftritt – ein eleganter, persönlicher Prozess in unserem Atelier.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-x-10 gap-y-12">
          {steps.map((s) => (
            <div key={s.n} className="relative pt-6 border-t border-[#E5E0D8]">
              <span className="font-display text-5xl text-gold/80">{s.n}</span>
              <h3 className="font-display text-2xl mt-3">{s.t}</h3>
              <p className="text-sm text-ink/70 mt-3 leading-relaxed">{s.d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
